import React from "react";
import { View, StyleSheet, Image } from "react-native";
import NtMarketingSectionContainer from "../general/NtMarketingSectionContainer";
import NtSectionTitle from "../general/NtSectionTitle";
import NtText from "../../../components/NtText";
import NtSectionDescription from "../general/NtSectionDescription";
import NtSectionBullet from "../general/NtSectionBullet";
import { useMobile } from "../../../hooks/useMobile";

function NtDevopsSuseSection(props) {
  const isMobile = useMobile();

  return (
    <NtMarketingSectionContainer
      style={[styles.container, isMobile ? { height: 600 } : {}]}
      backgroundImage={require("../../../assets/images/marketing/0f080021e59347ba9ef4a22112d31cc5f2cbaf0a.jpg")}
      opacity={0.1}
    >
      <View style={{ flex: 1, flexDirection: isMobile ? "column" : "row" }}>
        {/* left */}
        <View
          style={{
            flex: isMobile ? 0.5 : 1,
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Image
            style={[
              {
                width: 350,
                height: 350,
                resizeMode: "contain",
              },
            ]}
            source={require("../../../assets/images/marketing/devops-suse-logo.png")}
          />
        </View>

        {/* right */}
        <View style={{ flex: 1, justifyContent: "center" }}>
          <NtSectionTitle style={{ textAlign: "left", fontWeight: "300" }}>
            AS A{" "}
            <NtText style={{ fontWeight: "900" }}>SUSE GOLD PARTNER</NtText>, WE
            CAN HELP TRANSFORM YOU AND CLOUD NATIVE ENTERPRISE
          </NtSectionTitle>

          <NtSectionBullet containerStyle={{ marginTop: 30 }}>
            New cloud-native DevOps tools are emerging to transformation of IT
            teams in the enterprise.
          </NtSectionBullet>

          <NtSectionBullet containerStyle={{ marginTop: 30 }}>
            Maximize developer agility and flexibility by helping tech leaders
            bring products to market faster and accelerate your organization's
            digital transformation.
          </NtSectionBullet>

          <NtSectionBullet containerStyle={{ marginTop: 30 }}>
            Upskill your brightest talent to transform your infrastructure by
            leveraging the latest cloud-native technologies.
          </NtSectionBullet>
        </View>
      </View>
    </NtMarketingSectionContainer>
  );
}

const styles = StyleSheet.create({
  container: { height: 500 },
});

export default NtDevopsSuseSection;
